// Canonical GitHub owner/repo for this mock — comments worker, HelpAnchor
// source links, and changelog issue credits all read from here.
// On fork: update these three constants (see CLAUDE.md rename checklist).

export const GITHUB_OWNER = 'Airis-Analytica';
export const GITHUB_REPO = 'mock-ui-oem';
export const GITHUB_REPO_SLUG = `${GITHUB_OWNER}/${GITHUB_REPO}`;
export const GITHUB_ISSUES_BASE = `https://github.com/${GITHUB_REPO_SLUG}/issues/`;
